package com.yendo.mx.ui

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.yendo.mx.repository.HomeRepository
import com.yendo.mx.ui.home.HomeUiState
import com.yendo.mx.utils.ConfigManager
import com.yendo.mx.utils.EstadoCarga
import kotlinx.coroutines.ExperimentalCoroutinesApi
import kotlinx.coroutines.flow.SharingStarted
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.combine
import kotlinx.coroutines.flow.flatMapLatest
import kotlinx.coroutines.flow.flowOf
import kotlinx.coroutines.flow.stateIn

@OptIn(ExperimentalCoroutinesApi::class)
class HomeViewModel : ViewModel() {

    // 🚀 ÚNICA FUENTE DE LA VERDAD PARA LA UI
    val uiState: StateFlow<HomeUiState> = ConfigManager.estadoConfig
        .flatMapLatest { estado ->
            when (estado) {
                is EstadoCarga.Exito -> {
                    val zonaId = estado.id_zona
                    // Fusionamos los 3 flujos de Firebase en un solo estado
                    combine(
                        HomeRepository.observarSeccionesHome(zonaId),
                        HomeRepository.observarFiltrosHome(zonaId),
                        HomeRepository.observarTienditaLocal(zonaId)
                    ) { secciones, filtros, tiendita ->
                        HomeUiState(
                            isLoading = false,
                            secciones = secciones,
                            filtros = filtros,
                            tienditaLocal = tiendita
                        )
                    }
                }
                is EstadoCarga.Cargando -> {
                    flowOf(HomeUiState(isLoading = true))
                }
                is EstadoCarga.Error -> {
                    flowOf(HomeUiState(isLoading = false, errorMessage = "Error al cargar configuración: ${estado.mensaje}"))
                }
                else -> flowOf(HomeUiState(isLoading = true))
            }
        }
        .stateIn(
            scope = viewModelScope,
            started = SharingStarted.WhileSubscribed(5000), // Mantiene caché por 5 segundos si el usuario cambia de app
            initialValue = HomeUiState(isLoading = true)
        )
}
